module.exports = __webpack_public_path__ + "img/candy3.5d6eb20d.png";